<template>
    <div>
        <div class="ordbank-table desktop">
            <table class="inflection-table">
                <tr>
                    <th v-for="header_item in getHeadersByType('top')"
                        :colspan="header_item.colspan"
                        :rowspan="header_item.rowspan"
                    >{{ getTranslatedValue(header_item.value) }}</th>
                </tr>
                <tr>
                    <th v-for="header_item in getHeadersByType('sub')"
                        :colspan="header_item.colspan"
                        :rowspan="header_item.rowspan"
                    >{{ getTranslatedValue(header_item.value) }}</th>
                </tr>
                <tr v-for="(row_items, row_index) in getInflectionRows()">
                    <th v-for="header_item in (row_items.headers || [])"
                        v-if="header_item.show"
                        :rowspan="header_item.rowspan"
                    >
                        <div v-for="header_value in header_item.content_list">
                            {{ get_col_value(header_item, header_value) }}
                        </div>
                    </th>
                    <td v-for="(col_item, col_index) in row_items.cols"
                        v-if="col_item.show"
                        :class="getInflectionColumnClass(col_item)"
                        :rowspan="col_item.rowspan"
                        @focusin="handleMouseOver(true, getBoyingId('lexin-boying'), col_item)"
                        @focusout="handleMouseOver(false, getBoyingId('lexin-boying'), col_item)"
                        @mouseenter="handleMouseOver(true, getBoyingId('lexin-boying'), col_item)"
                        @mouseleave="handleMouseOver(false, getBoyingId('lexin-boying'), col_item)"
                    >
                        <div v-for="(col_value, col_value_index) in col_item.content_list">
                            <template v-if="colValueHasContent(col_value)">
                                <template v-if="col_value !== '-'">
                                    <span :id="getSpeakerId(row_index, col_index, col_value_index)" tabindex="0"><span v-if="col_item.prefix"><em>{{ col_item.prefix }} </em></span>{{ get_col_value(col_item, col_value) }}<span v-if="col_item.postfix"><em>{{ col_item.postfix }}</em></span></span>
                                    <SpeakTextContent />
                                    <ContentBlocks
                                        v-if="isKloyvdInfinitiv(col_item)"
                                        id="kloyvd_infinitiv"
                                        :params="{}"
                                        :contentId="getSpeakerId(row_index, col_index, col_value_index, 'kloyvd-infinitiv')"
                                    />
                                </template>
                                <div v-else class="mdash">
                                    &mdash;
                                </div>
                            </template>
                            <div v-else class="mdash">
                                &mdash;
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <div class="ordbank-table mobile horisontal">
            <table class="inflection-table">
                <tbody>
                <tr v-if="hasMobileInflectionRowHeaders()">
                    <th v-for="header_info in getMobileInflectionRowHeaders()" :colspan="header_info.colspan">
                        {{ $t(header_info.value) }}
                    </th>
                </tr>
                <tr v-for="(row_info, row_index) in getMobileInflectionRows()">
                    <th>{{ row_info.header }}</th>
                    <td v-for="(col_info, col_index) in row_info.list"
                        v-if="col_info.show"
                        :colspan="col_info.colspan"
                        :class="getInflectionColumnClass(col_info)"
                        @focusin="handleMouseOver(true, getBoyingId('lexin-boying'), col_info)"
                        @focusout="handleMouseOver(false, getBoyingId('lexin-boying'), col_info)"
                        @mouseenter="handleMouseOver(true, getBoyingId('lexin-boying'), col_info)"
                        @mouseleave="handleMouseOver(false, getBoyingId('lexin-boying'), col_info)"
                    >
                        <div v-if="col_info.content_list" v-for="content in col_info.content_list">
                            <template v-if="content !== '-'">
                                <span v-if="col_info.prefix"><em>{{ col_info.prefix }} </em></span><span :id="getBlockSpeakerId(row_index, col_index, 'content')">{{ content }}<span v-if="col_info.postfix"><em>{{ col_info.postfix }}</em></span></span>
                                <SpeakTextContent />
                                <ContentBlocks
                                    v-if="isKloyvdInfinitiv(col_info)"
                                    id="kloyvd_infinitiv"
                                    :params="{}"
                                    :contentId="getBlockSpeakerId(row_index, col_index, 'kloyvd-infinitiv')"
                                />
                            </template>
                            <div v-else class="mdash">
                                &mdash;
                            </div>
                        </div>
                        <div v-else class="mdash">
                            &mdash;
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import SpeakTextContent from "./SpeakTextContent.vue";
import Pronunciation from "./Pronunciation.vue";
import ContentBlocks from "./ContentBlocks.vue";

export default {
	name: 'LexinBoyingResultInflectionTable',
    components: {
        ContentBlocks,
        Pronunciation,
        SpeakTextContent
    },
    data() {
        return {
            'boyingResultMobile': {
                "inflection_rows": {},
                "inflection_rows_additional": {}
            }
        };
    },
	props:{
        boyingResult: {
            required: false,
            default: () => ({
                "headers": [],
                "sub_header": "",
                "sub_header_list": [],
                "lemma_rows": [],
                "inflection_rows": [],
                "inflection_rows_additional": []
            })
        },
        id: {
            required: false,
            default: "lexin-boying"
        },
        type: {
            required: false,
            default: "main"
        },
        languageCode: {
            required: false,
            default: ''
        }
	},
    created() {
        this.initMobile();
    },
	methods:{
        initMobile() {
            if (this.type !== 'additional' && this.boyingResult.inflection_rows !== undefined) {
                for (let i in this.boyingResult.inflection_rows) {
                    let inflectionRow = this.boyingResult.inflection_rows[i];

                    if (inflectionRow['cols'] !== undefined) {
                        for (let j in inflectionRow['cols']) {
                            // Clone column object.
                            let inflectionColumn = {...inflectionRow['cols'][j]};

                            if (this.boyingResultMobile['inflection_rows'][j] === undefined) {
                                this.boyingResultMobile['inflection_rows'][j] = {};
                                this.boyingResultMobile['inflection_rows'][j]['list'] = {};
                                this.boyingResultMobile['inflection_rows'][j]['header'] = "";

                                if (!this.boyingResultMobile['inflection_rows'][j]['header'] &&
                                    this.boyingResult.headers['headers']['mobile_left'] !== undefined &&
                                    this.boyingResult.headers['headers']['mobile_left'][j] !== undefined &&
                                    this.boyingResult.headers['headers']['mobile_left'][j]['value'] !== undefined) {
                                    let headerValue = this.boyingResult.headers['headers']['mobile_left'][j]['value'];
                                    if (this.$te(headerValue)) {
                                        this.boyingResultMobile['inflection_rows'][j]['header'] = this.$t(
                                            headerValue
                                        );
                                    } else {
                                        this.boyingResultMobile['inflection_rows'][j]['header'] = headerValue;
                                    }
                                }
                            }

                            inflectionColumn['colspan'] = inflectionColumn['rowspan'];
                            delete inflectionColumn['rowspan'];

                            this.boyingResultMobile['inflection_rows'][j]['list'][i] = inflectionColumn;
                        }
                    }
                }
            }

            if (this.type === 'additional' &&
                this.boyingResult.inflection_rows_additional !== undefined &&
                this.boyingResult.inflection_rows_additional.rows !== undefined) {

                for (let i in this.boyingResult.inflection_rows_additional.rows) {
                    let inflectionRow = this.boyingResult.inflection_rows_additional.rows[i];

                    if (inflectionRow !== undefined && inflectionRow['cols'] !== undefined) {
                        for (let j in inflectionRow['cols']) {
                            // Clone column object.
                            let inflectionColumn = {...inflectionRow['cols'][j]};

                            if (this.boyingResultMobile['inflection_rows_additional'][j] === undefined) {
                                this.boyingResultMobile['inflection_rows_additional'][j] = {};
                                this.boyingResultMobile['inflection_rows_additional'][j]['list'] = {};
                                this.boyingResultMobile['inflection_rows_additional'][j]['header'] = "";

                                if (!this.boyingResultMobile['inflection_rows_additional'][j]['header'] &&
                                    this.boyingResult.headers['headers_additional']['mobile_left'] !== undefined &&
                                    this.boyingResult.headers['headers_additional']['mobile_left'][j] !== undefined &&
                                    this.boyingResult.headers['headers_additional']['mobile_left'][j]['value'] !== undefined) {
                                    let headerValue = this.boyingResult.headers['headers_additional']['mobile_left'][j]['value'];
                                    if (this.$te(headerValue)) {
                                        this.boyingResultMobile['inflection_rows_additional'][j]['header'] = this.$t(
                                            headerValue
                                        );
                                    } else {
                                        this.boyingResultMobile['inflection_rows_additional'][j]['header'] = headerValue;
                                    }
                                }
                            }

                            inflectionColumn['colspan'] = inflectionColumn['rowspan'];
                            delete inflectionColumn['rowspan'];

                            this.boyingResultMobile['inflection_rows_additional'][j]['list'][i] = inflectionColumn;
                        }
                    }
                }
            }
        },
        getInflectionRows() {
            let rows = [];
            let fieldName = 'inflection_rows';

            if (this.type === 'additional') {
                fieldName = 'inflection_rows_additional';
            }

            if (this.boyingResult[fieldName] !== undefined) {
                if (this.type === 'additional') {
                    if (this.boyingResult[fieldName].rows !== undefined) {
                        rows = this.boyingResult[fieldName].rows;
                    }
                } else {
                    rows = this.boyingResult[fieldName];
                }
            }

            return rows;
        },
        getHeadersByType(type) {
            let value = [];

            let group = 'headers';
            if (this.type === 'additional') {
                group = 'headers_additional';
            }

            if (this.boyingResult.headers !== undefined &&
                this.boyingResult.headers[group] !== undefined &&
                this.boyingResult.headers[group][type] !== undefined) {
                value = this.boyingResult.headers[group][type];
            }

            return value;
        },
        hasHeaderValue() {
            let value = false;
            if (this.getHeaderValue() !== '') {
                value = true;
            }

            return value;
        },
        getHeaderValue() {
            let value = '';

            if (this.boyingResult.headers !== undefined && this.boyingResult.headers.header !== undefined) {
                if (this.$te(this.boyingResult.headers.header)) {
                    value = this.$t(this.boyingResult.headers.header);
                } else {
                    value = this.boyingResult.headers.header;
                }
            } else if (this.boyingResult.header !== undefined) {
                if (this.$te(this.boyingResult.header)) {
                    value = this.$t(this.boyingResult.header);
                } else {
                    value = this.boyingResult.header;
                }
            }

            return value;
        },
        getTranslatedValue(value) {
            if (this.$te(value)) {
                return this.$t(value);
            } else {
                return value;
            }
        },
        hasMobileInflectionRowHeaders() {
            let value = false;

            let fieldName = 'headers';
            if (this.type === 'additional') {
                fieldName = 'headers_additional';
            }

            if (this.boyingResult['headers'] !== undefined &&
                this.boyingResult['headers'][fieldName] !== undefined &&
                this.boyingResult['headers'][fieldName]['mobile_top'] !== undefined &&
                this.getListLength(this.boyingResult['headers'][fieldName]['mobile_top']) > 0) {
                value = true;
            }

            return value;
        },
        getMobileInflectionRowHeaders() {
            let value = [];

            let fieldName = 'headers';
            if (this.type === 'additional') {
                fieldName = 'headers_additional';
            }

            if (this.boyingResult['headers'] !== undefined &&
                this.boyingResult['headers'][fieldName] !== undefined &&
                this.boyingResult['headers'][fieldName]['mobile_top'] !== undefined) {
                value = this.boyingResult['headers'][fieldName]['mobile_top'];
            }

            return value;
        },
        getMobileInflectionRows() {
            let value = [];

            let fieldName = 'inflection_rows';
            if (this.type === 'additional') {
                fieldName = 'inflection_rows_additional';
            }

            if (this.boyingResultMobile[fieldName] !== undefined) {
                value = this.boyingResultMobile[fieldName];
            }

            return value;
        },
        get_col_value(col_item, col_value) {
            let value = col_value;
            if (col_item.is_translation_key !== undefined && col_item.is_translation_key === true) {
                value = this.$t(col_value);
            }

            return value;
        },
        colValueHasContent(col_value) {
            let value = false;
            if (col_value && col_value !== '-') {
                value = true;
            }

            return value;
        },
        hasTopHeader() {
            let value = false;
            if (this.boyingResult.headers !== undefined &&
                this.boyingResult.headers.headers !== undefined &&
                this.boyingResult.headers.headers.top !== undefined &&
                this.getListLength(this.boyingResult.headers.headers.top) > 0) {
                value = true;
            }

            return value;
        },
        hasContent() {
            let value = false;

            if (this.getListLength(this.boyingResult.inflection_rows) > 0 &&
                this.getListLength(this.boyingResult.headers) > 0) {
                value = true;
            }

            return value;
        },
        getInflectionColumnClass(item) {
            let value = 'cell';
            if (item.class_list !== undefined) {
                value += ' ' + item.class_list.join(' ');
            }

            return value;
        },
        getListLength(list) {
            let length = 0;

            if (typeof list == "object" && Object.keys(list).length > 0) {
                length = Object.keys(list).length;
            } else if (typeof list == "array") {
                length = list.length;
            }

            return length;
        },
        getMetaGridClass() {
            let value = 'grid-table';
            let headerCount = this.getListLength(this.boyingResult.headers);
            if (headerCount > 0) {
                value += ' g-col-' + headerCount;
            }
            value += ' g-m-col-2';
            return value;
        },
        getBoyingId(rootId) {
            const id = this.id + "-" + rootId + '-' + this.languageCode;

            return id;
        },
        getlemmaSpeakerId(rowIndex) {
            const id = this.id + "-lemma-" + rowIndex;

            return id;
        },
        getSpeakerId(rowIndex, colIndex, col_value_index = 0, postfix = '') {
            let id = this.id + "-" + rowIndex + "-" + colIndex + "-" + col_value_index;
            if (postfix) {
                id += "-" + postfix;
            }

            return id;
        },
        getBlockSpeakerId(rowIndex, colIndex, postfix) {
            return this.getSpeakerId(rowIndex, colIndex) + postfix;
        },
        getRowClass(rowIndex) {
            return "cell g-row-" + rowIndex;
        },
        getColumnValue(column_value) {
            let value = '';
            if (typeof column_value === "object" && column_value['value'] !== undefined) {
                value = column_value.value;
            } else if (typeof column_value === "string") {
                value = column_value;
            }

            return value;
        },
        getDataHeader(colIndex) {
            let value = '';

            if (this.boyingResult.headers[colIndex] !== undefined) {
                value = this.boyingResult.headers[colIndex];
            }

            return value;
        },
        handleMouseOver(mouseOver, rootElementId, item) {
            this.$emit('updateMouseOver', mouseOver, rootElementId, item);
        },
        isKloyvdInfinitiv(params) {
            let value = false;
            if (typeof params === "object" &&
                params.settings !== undefined &&
                params.settings.includes("kloyvd_infinitiv")) {
                value = true;
            }

            return value;
        }
    },
    computed: {
    }
}
</script>
